const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/components/HelpDialog/HelpDialog.tsx';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import textMap from './translations';
import { TextInput, useOptionalText, useText } from '../../../../utils/intlUtils';

interface Props {
    title: TextInput;
    text?: TextInput;
    isOpen: boolean;
    onClose: () => void;
}

export const HelpDialog = (props: Props) => {
    const { formatMessage } = useIntl();
    const title = useText(props.title);
    const text = useOptionalText(props.text);

    return (
        <Dialog open={props.isOpen} onClose={props.onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{text}</DialogContent>
            <DialogActions>
                <Button variant="text" color="primary" onClick={props.onClose}>
                    {formatMessage(textMap.okBtn)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
